export enum Roles {
    ADMIN = 'Administrator',
    SHIFTLEAD = 'Schichtleiter',
    MONITOR = 'Viewer',
    SYSTEM_SAPMAILFETCHER = 'SYSTEM_SAPMAILFETCHER'
}
